export const environment = {
  production: true,
   apiUrl: 'https://buyonventora.com/api'
  //apiUrl: 'http://localhost:5000/api'
};
